import { RootState } from '@/lib/store';
import { GridCell } from '@/models/bet/grid/cell';
import { BetStatusId } from '@/models/bet/status/id';
import { AudioService } from '@/services/AudioService';
import { Image } from '@starsoft/common/components';
import Head from 'next/head';
import { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { MinesBoardCellProps } from './props';
import styles from './styles.module.scss';

function MinesBoardCell({
  bet,
  isDisabled,
  position,
  onClick,
  isBackgroundPaper,
}: MinesBoardCellProps) {
  const GemImage = `${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/mines/gem.png`;
  const BombImage = `${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/mines/bomb.png`;
  const sound: boolean = useSelector(
    (state: RootState) => state.gamesAudio.sound,
  );

  const item =
    bet?.status?.status?.id?.toString() != BetStatusId.Open?.toString()
      ? bet?.grid?.cells?.[position]
      : bet?.grid?.clickedCells?.[position];

  const hoverSound = useCallback(() => {
    if (sound) {
      AudioService.mineHover();
    }
  }, [sound]);

  return (
    <div
      className={`${styles['container']} ${
        bet == null ||
        bet?.status?.status?.id?.toString() != BetStatusId.Open?.toString() ||
        item != GridCell.Empty
          ? styles['container--disabled']
          : ''
      }`}
      key={`mines_card_board_${position}`}
      onClick={() => onClick(position)}
    >
      <Head>
        <link rel="preload" href={GemImage} />
        <link rel="preload" href={BombImage} />
      </Head>
      <div
        className={`${styles['container__card']} ${isBackgroundPaper ? styles['container__card--paper'] : ''} ${
          bet == null ||
          bet?.status?.status?.id?.toString() != BetStatusId.Open?.toString() ||
          isDisabled
            ? styles['container__card--disabled']
            : ''
        } ${
          !!bet &&
          bet?.status?.status?.id?.toString() != BetStatusId.Open?.toString()
            ? styles['container__card--turn']
            : ''
        } ${
          !!bet && item != GridCell.Empty
            ? styles['container__card--selected']
            : ''
        } ${
          bet?.grid?.clickedCells?.[position] != GridCell.Empty
            ? styles['container__card--clicked']
            : ''
        }`}
        onMouseEnter={hoverSound}
      >
        <div className={styles['container__card__front']} />
        <div className={styles['container__card__back']}>
          {item && item != GridCell.Empty && (
            <Image
              className={styles['container__card__back__image']}
              src={item == GridCell.Diamond ? GemImage : BombImage}
              alt={`image-card-${position}`}
              width={100}
              height={100}
              secondarySkeleton
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default memo(MinesBoardCell);
